// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3rf2a","delete":"styles_delete__11N-U","update":"styles_update__3DEaQ","add":"styles_add__3JMUw"};